(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('phoneInputForm', phoneInputForm);

    function phoneInputForm() {
        //binding document: https://stackoverflow.com/a/37818829
        var directive = {
            templateUrl: '/app/common/phone-input.html',
            scope: {
                input: '=', // model connection
                isRegistered: '=', // returns registration status
                isRequired: '<', // check if required
                isValid: '=', // returns validation status
                phoneChanged: '=', // returns phone change status
                hasOtp: '<', //check if require OTP
                waitingOtp: '=', //check if OTP is waiting
                otpType: '@',
                name: '@',
                isDisabled: '=',
                selectionDisabled: '<', //disable country selection
                selectedCode: '@', //selected country code
                checkRegistered: '<', //check if registered
                handleOnChange: '&',
                handleOnBlur: '&',
                handleOnClick: '&',
                handleOtpVerify: '&',
                disableWarning: '<',
                showBubbleMessage: '<', //shows additional notifier messages
                hideRegisteredWarning: '<', //hides registered warning
                // Captcha bindings (active when hasOtp !== false)
                etToken: '=', // two-way binding for turnstile token
                captchaVerified: '=', // true when turnstile + eimage captcha are both valid
                isTurkishPhone: '=', // two-way binding for Turkish phone status
                eimageCaptchaKey: '=', // two-way binding for eimage captcha key
                eimageCaptchaValue: '=' // two-way binding for eimage captcha value
            },
            restrict: 'EA',
            controller: phoneInputFormController,
            controllerAs: 'vm',
            bindToController: true,
            link: function (scope, elm, attrs) {
                if (attrs.selectedCode) {
                    setTimeout(function () {
                        scope.vm.selectedCountry = scope.vm.countries.find(c => c.callingCode === attrs.selectedCode);
                    });
                }

                // Initialize Bootstrap dropdown
                setTimeout(function () {
                    var $dropdown = elm.find('.dropdown');
                    var $button = elm.find('.country-dropdown-btn');
                    var $menu = elm.find('.dropdown-menu');

                    if ($button.length === 0) {
                        return;
                    }

                    // Manual dropdown toggle
                    $button.on('click', function (e) {
                        // Don't handle if button is disabled
                        if ($button.is(':disabled')) {
                            return;
                        }

                        e.preventDefault();
                        e.stopPropagation();

                        var isOpen = $dropdown.hasClass('open');

                        // Close all other dropdowns
                        $('.dropdown').removeClass('open');

                        // Toggle this dropdown
                        if (!isOpen) {
                            $dropdown.addClass('open');
                            $button.attr('aria-expanded', 'true');
                        } else {
                            $dropdown.removeClass('open');
                            $button.attr('aria-expanded', 'false');
                        }
                    });

                    // Close dropdown when clicking outside
                    $(document).on('click.phoneDropdown', function (e) {
                        // Don't close if clicking the button itself or its children
                        if ($button.is(e.target) || $button.has(e.target).length > 0) {
                            return;
                        }

                        // Close if clicking outside the dropdown
                        if (!$dropdown.is(e.target) && $dropdown.has(e.target).length === 0) {
                            $dropdown.removeClass('open');
                            $button.attr('aria-expanded', 'false');
                        }
                    });

                    // Close dropdown when selecting a country
                    $menu.find('li a').on('click', function () {
                        setTimeout(function () {
                            $dropdown.removeClass('open');
                            $button.attr('aria-expanded', 'false');
                        }, 100);
                    });

                    // Cleanup on destroy
                    scope.$on('$destroy', function () {
                        $button.off('click');
                        $menu.find('li a').off('click');
                        $(document).off('click.phoneDropdown');
                    });
                }, 500);
            }
        };
        return directive;

    }

    phoneInputFormController.$inject = ['countriesCodesService', '$translate', 'notifierSvc', 'otpService', 'user_factory', '$rootScope', '$timeout', '$scope'];
    function phoneInputFormController(countriesCodesService, $translate, notifierSvc, otpService, user_factory, $rootScope, $timeout, $scope) {
        var vm = this;
        vm.countries = countriesCodesService;
        vm.phoneChanged = false;
        vm.showMenu = false;

        // Turnstile configuration
        var isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
        var TURNSTILE_SITE_KEY = isLocalhost ? '1x00000000000000000000AA' : '0x4AAAAAACNleg3E3Cw7A_b0';
        var turnstileWidgetId = null;
        var turnstileDebounceTimer = null; // Debounce timer for Turnstile initialization
        var TURNSTILE_DEBOUNCE_DELAY = 500; // 500ms debounce delay
        vm.turnstileContainerId = 'turnstile-container-' + $scope.$id; // Unique ID for each directive instance
        vm.isTurkishPhone = true; // Default to Turkish phone

        // Internal captcha states
        var turnstileVerified = false;
        vm.eimageCaptchaKey = null;
        vm.eimageCaptchaValue = null;
        vm.captchaRemainingAttempts = null;

        vm.updateCaptchaVerified = function (captchaValue) {
            if (typeof captchaValue !== 'undefined') {
                vm.eimageCaptchaValue = captchaValue;
            }
            vm.captchaVerified = turnstileVerified && !!vm.eimageCaptchaValue;
        };

        var initCountry;

        //bind country code
        setTimeout(function () {
            window.oldPhoneNumber = vm.input;
            var controlCountry;
            if (vm.input === '' || !vm.input || !vm.input.length) {
                vm.input = undefined;
            }
            else {
                for (var i = 5; i > 1; --i) {
                    var controlCode = vm.input.slice(0, i);
                    controlCountry = vm.countries.find(function (code) {
                        return code.callingCode === controlCode;
                    });
                    if (controlCountry) {
                        break;
                    }
                }
            }
            initCountry = controlCountry ? controlCountry : window.lang == 'tr' ? {
                "name": "Turkiye",
                "code": "TR",
                "callingCode": "+90"
            } : window.lang == 'es-ES' ? {
                "name": "Spain",
                "code": "ES",
                "callingCode": "+34"
            } : window.lang == 'pt-PT' ? {
                "name": "Portugal",
                "code": "PT",
                "callingCode": "+351"
            } : {
                "name": "United Kingdom",
                "code": "GB",
                "callingCode": "+44"
            };

            vm.selectedCountry = initCountry;


            vm.checkCallingCode();

            $('#phone-nput').focus(function () {
                var that = this;
                setTimeout(function () { that.selectionStart = that.selectionEnd = 10000; }, 0);
            });

        });


        vm.selectCountry = function (country) {
            vm.input = vm.input && vm.input.length ? vm.input.replace(vm.selectedCountry.callingCode, country.callingCode) : vm.input;
            vm.selectedCountry = country;

            var isValid = false;
            if (vm.input)
                isValid = window.libphonenumber.isValidPhoneNumber(vm.input, vm.selectedCountry.code);
            if (isValid)
                vm.input = window.libphonenumber.parsePhoneNumber(vm.input, vm.selectedCountry.code).formatInternational();
            vm.checkCallingCode();
        };

        vm.showRequireOtp = function () {
            return !vm.isDisabled && vm.hasOtp && vm.phoneChanged && !vm.isRegistered && vm.input && vm.input.length && vm.phoneChanged && vm.isValid && !vm.disableWarning && !vm.isFirstPhone;
        };

        vm.showError = function () {
            return !vm.isDisabled && vm.phoneChanged && (!vm.isValid || (vm.isRegistered && !vm.hideRegisteredWarning) || (!vm.input && vm.isRequired)) && !vm.disableWarning && !vm.isFirstPhone;
        };

        vm.checkCallingCode = function () {
            vm.isValid = true;
            if (typeof vm.isDisabled !== "undefined")
                vm.isDisabled = false;
            if (typeof vm.isRegistered !== "undefined")
                vm.isRegistered = false;

            vm.isFirstPhone = ($rootScope.recommendedFieldsToFill && $rootScope.recommendedFieldsToFill.isPhoneNumberFilled && !$rootScope.recommendedFieldsToFill.isPhoneConfirmed) ? false : (vm.input && window.oldPhoneNumber && vm.input.replaceAll(' ', '').replace('+', '') === window.oldPhoneNumber.replaceAll(' ', '').replace('+', ''));
            vm.phoneChanged = !vm.isFirstPhone;

            if ((!vm.input || vm.input.length === 0) && vm.isRequired) {
                vm.isValid = false;
                vm.phoneChanged = false;
                return;
            }

            if (vm.input) {
                vm.isValid = window.libphonenumber.isValidPhoneNumber(vm.input, vm.selectedCountry.code);
                vm.input = window.libphonenumber.parsePhoneNumber(vm.input, vm.selectedCountry.code).formatInternational();
            }
            else if (vm.isRequired) {
                vm.isValid = false;
            }

            if (vm.isValid && vm.checkRegistered && vm.input) {
                if (typeof vm.isDisabled !== "undefined")
                    vm.isDisabled = true;
                if (typeof vm.isRegistered !== "undefined")
                    vm.isRegistered = true;
                var checkPhone = user_factory.any({ phone: vm.input.replace(/\s/g, '') });
                checkPhone.$promise.then(function (response) {
                    if (response.result) {
                        if (vm.showBubbleMessage && !vm.hideRegisteredWarning)
                            $translate('valid_email21').then(function (translation2) {
                                notifierSvc.show({ message: translation2, type: "error" });
                            });
                        if ($rootScope.recommendedFieldsToFill && $rootScope.recommendedFieldsToFill.isPhoneNumberFilled && !$rootScope.recommendedFieldsToFill.isPhoneConfirmed)
                            vm.isRegistered = false;
                    }
                    else {
                        if (typeof vm.isRegistered !== "undefined")
                            vm.isRegistered = false;
                    }
                }, function () {
                    if (typeof vm.isRegistered !== "undefined")
                        vm.isRegistered = false;
                }).finally(() => {
                    if (typeof vm.isDisabled !== "undefined")
                        vm.isDisabled = false;
                });
            }
            vm.waitingOtp = vm.showRequireOtp();
            // if (window.oldPhoneNumber && window.oldPhoneNumber.length && (!vm.input || !vm.input.length)) {
            //     window.oldPhoneNumber = undefined;
            // }
            handleChange();
        };

        vm.updateCountryCode = function () {
            var controlCountry;
            if (vm.input === '' || !vm.input || !vm.input.length) {
                vm.input = undefined;
            }
            else
                for (var i = 5; i > 1; --i) {
                    var controlCode = vm.input.slice(0, i);
                    controlCountry = vm.countries.find(function (code) {
                        return code.callingCode === controlCode;
                    });
                    if (controlCountry) {
                        vm.selectedCountry = controlCountry;
                        break;
                    }
                }
        };

        vm.callOtp = function () {
            vm.loading = true;
            vm.phoneChanged = true;
            var ETToken = !vm.isTurkishPhone ? vm.etToken : null;
            var eimageCaptchaData = !vm.isTurkishPhone && vm.eimageCaptchaKey ? { key: vm.eimageCaptchaKey, value: vm.eimageCaptchaValue } : null;
            var otpType = vm.otpType || "profileUpdate";
            var verificationAddress = otpType === "loginAndRegister" ? vm.input : vm.input.replace("+", "");
            otpService.callOtp(otpType, 1, verificationAddress, null, null, ETToken, eimageCaptchaData).then(function (resp) {
                vm.loading = false;
                otpService.closeDialog();
                // Reset Turnstile token after use
                resetTurnstile();
                // Reset EImage-Captcha after use
                resetEimageCaptcha();
                if (!resp) {
                    return;
                }
                vm.phoneChanged = false;
                window.oldPhoneNumber = vm.input;
                vm.waitingOtp = vm.showRequireOtp();
                vm.handleOtpVerify({ response: resp });
            }, function (err) {
                otpService.closeDialog();
                vm.loading = false;
                // Handle captcha error from sevc endpoint
                if (err.data && typeof err.data.remainingAttempts !== 'undefined') {
                    vm.captchaRemainingAttempts = err.data.remainingAttempts;
                    vm.eimageCaptchaValue = null;
                    vm.updateCaptchaVerified();
                } else {
                    // Reset Turnstile token on error
                    resetTurnstile();
                    // Reset EImage-Captcha on non-captcha errors
                    resetEimageCaptcha();
                    if (err.validateRequest)
                        retryOTP(err.validateRequest);
                }
            }).finally(() => {
            });
        };

        function retryOTP(validateRequest) {
            vm.loading = true;
            vm.phoneChanged = true;
            otpService.callOtp('retry', validateRequest.verificationType, validateRequest.verificationAddress, validateRequest.codeExpireDate, validateRequest.verificationToken).then(
                function (resp) {
                    vm.loading = false;
                    otpService.closeDialog();
                    if (!resp) {
                        return;
                    }
                    vm.phoneChanged = false;
                    window.oldPhoneNumber = vm.input;
                    vm.waitingOtp = vm.showRequireOtp();
                    vm.handleOtpVerify({ response: resp });
                },
                function (err) {
                    otpService.closeDialog();
                    retryOTP(err.validateRequest);
                }
            );
        }



        var stopExecution = false;
        vm.reactivityForCountryCode = function () {
            function sleep() {
                return new Promise(function (resolve) {
                    setTimeout(resolve, 150);
                });
            }
            async function process() {
                while (!stopExecution) {
                    if (vm.input && vm.input.length && vm.input.startsWith(vm.selectedCountry.callingCode)) {
                        break;
                    }
                    await sleep();
                    await vm.updateCountryCode();
                }
            }
            process();
        };
        vm.reactivityForCountryCode();
        vm.$onDestroy = function () {
            stopExecution = true;
        };
        const handleChange = function () {
            if (vm.handleOnChange)
                vm.handleOnChange({ input: vm.input });

            // Always update Turkish phone status
            vm.isTurkishPhone = isTurkishNumber(vm.input);

            // Handle Turnstile for non-Turkish phones (active when hasOtp is not false)
            if (vm.hasOtp !== false) {
                // Cancel any pending debounce timer
                if (turnstileDebounceTimer) {
                    $timeout.cancel(turnstileDebounceTimer);
                    turnstileDebounceTimer = null;
                }

                // Only initialize Turnstile if phone is valid and not Turkish
                if (!vm.isTurkishPhone && vm.isValid) {
                    // Debounce Turnstile initialization
                    turnstileDebounceTimer = $timeout(function () {
                        initializeTurnstile();
                        turnstileDebounceTimer = null;
                    }, TURNSTILE_DEBOUNCE_DELAY);
                } else {
                    resetTurnstile();
                    resetEimageCaptcha();
                }
            }
        };
        vm.handleClick = function () {
            vm.handleOnClick();
        };
        vm.handleBlur = function () {
            vm.handleOnBlur({ input: vm.input });
        };

        // Turnstile Functions
        function isTurkishNumber(phoneNumber) {
            if (!phoneNumber) return true;
            var cleanNumber = phoneNumber.replace(/\s+/g, '');
            return cleanNumber.startsWith('+90');
        }

        function loadTurnstileScript() {
            return new Promise(function (resolve, reject) {
                if (window.turnstile) {
                    resolve();
                    return;
                }

                var script = document.createElement('script');
                script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
                script.async = true;
                script.defer = true;
                script.onload = function () {
                    resolve();
                };
                script.onerror = function () {
                    reject(new Error('Failed to load Turnstile script'));
                };
                document.head.appendChild(script);
            });
        }

        function initializeTurnstile() {
            if (vm.hasOtp === false) return;

            loadTurnstileScript().then(function () {
                $timeout(function () {
                    var container = document.getElementById(vm.turnstileContainerId);
                    if (!container) return;

                    // Remove existing widget if any
                    if (turnstileWidgetId !== null) {
                        try {
                            window.turnstile.remove(turnstileWidgetId);
                        } catch (e) {
                            // Widget may already be removed
                        }
                        turnstileWidgetId = null;
                    }

                    // Clear container
                    container.innerHTML = '';

                    // Determine theme based on dark mode
                    var isDarkMode = window.darkMode || false;
                    var theme = isDarkMode ? 'dark' : 'light';

                    // Render new widget
                    turnstileWidgetId = window.turnstile.render(container, {
                        sitekey: TURNSTILE_SITE_KEY,
                        theme: theme,
                        size: 'normal',
                        callback: function (token) {
                            $scope.$apply(function () {
                                vm.etToken = token;
                                turnstileVerified = true;
                                vm.updateCaptchaVerified();
                            });
                        },
                        'expired-callback': function () {
                            $scope.$apply(function () {
                                vm.etToken = null;
                                turnstileVerified = false;
                                vm.updateCaptchaVerified();
                            });
                        },
                        'error-callback': function () {
                            $scope.$apply(function () {
                                vm.etToken = null;
                                turnstileVerified = false;
                                vm.updateCaptchaVerified();
                            });
                        }
                    });
                }, 50);
            });
        }

        function resetTurnstile() {
            turnstileVerified = false;
            vm.etToken = null;
            vm.updateCaptchaVerified();
            if (turnstileWidgetId !== null && window.turnstile) {
                try {
                    window.turnstile.remove(turnstileWidgetId);
                } catch (e) {
                    // Widget may already be removed
                }
                turnstileWidgetId = null;
            }
        }

        function resetEimageCaptcha() {
            vm.eimageCaptchaKey = null;
            vm.eimageCaptchaValue = null;
            vm.updateCaptchaVerified();
        }

        vm.resetTurnstileWidget = function () {
            turnstileVerified = false;
            vm.etToken = null;
            vm.updateCaptchaVerified();
            if (turnstileWidgetId !== null && window.turnstile) {
                try {
                    window.turnstile.reset(turnstileWidgetId);
                } catch (e) {
                    // If reset fails, re-initialize
                    initializeTurnstile();
                }
            }
        };

        // Listen for dark mode changes to update Turnstile theme
        var unbindDarkMode = $scope.$on('darkMode:changed', function (e, data) {
            if (vm.hasOtp !== false && !vm.isTurkishPhone && turnstileWidgetId !== null) {
                // Re-render Turnstile with new theme
                initializeTurnstile();
            }
        });

        // Cleanup on destroy
        vm.$onDestroy = function () {
            stopExecution = true;
            // Cancel debounce timer
            if (turnstileDebounceTimer) {
                $timeout.cancel(turnstileDebounceTimer);
                turnstileDebounceTimer = null;
            }
            // Clean up Turnstile widget
            if (turnstileWidgetId !== null && window.turnstile) {
                try {
                    window.turnstile.remove(turnstileWidgetId);
                } catch (e) {
                    // Widget may already be removed
                }
            }
            // Unbind dark mode listener
            if (unbindDarkMode) {
                unbindDarkMode();
            }
        };
    }
})();
